export default __webpack_public_path__ + "static/media/plant-del-icon.fd40a047.svg";